import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App)
    .use(store)
    .use(router);

if (process.env.VUE_APP_USE_MOCK === 'true') {
    const requireMock = require.context('./mock', false, /\.js$/);
    const allMocks = {};

    requireMock.keys().forEach(key => {
        const name = key.replace(/^\.\/(.*)\.js$/, '$1');
        allMocks[name] = requireMock(key).default;
    });

    app.config.globalProperties.$mocks = allMocks;
}

app.mount("#app");
